/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Case_Exception_StaleInputs */

const en_api_error_case_exception_stale = /** @type {(inputs: Api_Error_Case_Exception_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The review task no longer matches the case stage.`)
};

const pt_br2_api_error_case_exception_stale = /** @type {(inputs: Api_Error_Case_Exception_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tarefa de revisão não corresponde mais à etapa do caso.`)
};

/**
* | output |
* | --- |
* | "The review task no longer matches the case stage." |
*
* @param {Api_Error_Case_Exception_StaleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_case_exception_stale = /** @type {((inputs?: Api_Error_Case_Exception_StaleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Case_Exception_StaleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_case_exception_stale(inputs)
	return pt_br2_api_error_case_exception_stale(inputs)
});